import styles from './Terms.scss';
import Head from 'next/head';

export const Terms: React.FC = () => {
  return (
    <>
      <Head>
        <title>利用規約 | Teach You</title>
      </Head>
      <main>
        <h1>利用規約</h1>
        <p>
          この利用規約（以下「本利用規約」といいます。）は、ちょっと株式会社（以下「当社」といいます。）が提供するオンラインスクール作成支援システム「teach&nbsp;you」（以下「本サービス」といいます。）の利用条件を定めるものです。本サービスを利用するためには、本利用規約の全てに同意していただく必要があり、本サービスを利用したときは、本利用規約に同意したものとみなします。本サービスをご利用される前に必ず本利用規約をよくお読みください。
        </p>
        <h2>第１章 スクール運営者について</h2>
        <h3>第 1 条 会員資格</h3>
        <ol>
          <li>
            会員とは、本利用規約に同意の上、次条に基づいて当社が定める方法により本サービス利用のために入会を申し込み、適正な手続を経て当社が承諾した者をいいます。
          </li>
          <li>
            当社は、本サービスを提供するにあたり、本利用規約のほか、ガイドラインその他の規程（以下「ガイドライン等」といいます。）を定めることがあります。会員は、次条の入会申請又は本サービスの利用によって、本利用規約及びガイドライン等に同意したものとみなします。
          </li>
          <li>
            当社は、本サービスの提供にあたり、決済サービスその他の第三者が提供するサービス（以下「外部サービス」といいます。）を用いることがあります。会員は、本サービスを利用するにあたり、あらかじめ当社が外部サービスを用いることにつき同意するとともに、当該第三者に対し当該第三者が定める利用規約その他の条件に同意しなければなりません。
          </li>
        </ol>
        <h3>第 2 条 入会申請</h3>
        <ol>
          <li>
            会員となることを希望する者（以下「入会希望者」といいます。）は、会員となる本人がオンラインにより本サービスについて別途当社が指定する方法により入会を申し込むものとします（以下「入会申請」といいます。）。入会希望者は、入会申請にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません（以下、当社に提供された情報を「登録情報」といいます。）。
          </li>
          <li>
            入会申請は、前項の申込みに対する当社の承諾をもって完了するものとし、当該完了をもって入会希望者は会員となります。
          </li>
          <li>
            入会申請完了時に、本利用規約を内容とする本サービスの利用契約（以下「利用契約」といいます。）が会員と当社との間に成立し、会員は、別途当社の定める方法により本サービスを利用することができます。
          </li>
          <li>
            当社は、入会希望者が、以下の各号のいずれかの事由に該当する場合は、入会申請を拒否し、又は当該会員による本サービスの利用を制限することがあります。
            <ol>
              <li>本利用規約に違反するおそれがあると当社が判断した場合</li>
              <li>登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合</li>
              <li>過去に本サービスの利用を停止され、又はを会員登録を取り消された者である場合</li>
              <li>
                未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意を得ていなかった場合
              </li>
              <li>
                暴力団、暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標榜ゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下「反社会的勢力等」という。）であり、又は反社会的勢力等が経営を支配若しくは経営に実質的に関与していると認められる関係を有し、若しくは資金提供その他の便益の供与によって反社会的勢力等と何らかの交流を行っていると当社が判断した場合
              </li>
              <li>
                暴力的な要求行為、法的な責任を超えた不当な要求行為、取引に関して、脅迫的な言動をし、又は暴力を用いる行為、風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為を行っていると当社が判断した場合
              </li>
              <li>その他、当社が入会を適当でないと判断した場合</li>
            </ol>
          </li>
        </ol>
        <h3>第 3 条 アカウントの管理</h3>
        <ol>
          <li>
            会員は、会員が当社の定めるところに従い本サービス上で設定するメールアドレス及びパスワード（以下「アカウント」といいます。）の管理を行う責任を負うものとします。
          </li>
          <li>
            会員は、アカウントを第三者に利用させ、又は貸与し、譲渡し、名義を変更し、若しくは担保権の設定その他の処分をすることはできません。
          </li>
          <li>
            アカウントの管理不十分、使用上の過誤、第三者の使用等による損害の責任は会員が負うものとし、当社は一切の責任を負いません。
          </li>
          <li>
            会員は、アカウントが第三者に漏洩し、又は盗用されている疑いがある場合には、直ちに当社にその旨を連絡するとともに、当社の指示がある場合にはこれに従うにものとします。この場合、当社は、当該アカウントを停止でき、当該停止によって会員に生じた損害について一切の責任を負いません。
          </li>
        </ol>
        <h3>第 4 条 サービスの利用</h3>
        <p>会員は、本利用規約のほか、当社が定める方法に従い、本サービスを利用することができます。</p>
        <h3>第 5 条 スクールの運営方法</h3>
        <ol>
          <li>
            会員は、本サービスを用いて作成したウェブサイトにおいて、会員の顧客に対し、動画配信等のサービス（以下「スクールサービス」といいます。）を提供することができます。会員は、スクールサービスについて問い合わせがあった場合、受講料の額その他取引に必要な情報について回答しなければなりません。
          </li>
          <li>
            会員は、顧客に対し、自己の責任及び負担によりスクールサービスを運営するものとし、当社は一切の責任及び負担を負いません。
          </li>
          <li>
            会員は、顧客に対し、スクールサービスの提供主体が会員であることについてウェブサイト上に明示するものとします。
          </li>
          <li>
            会員は、顧客に対し、スクールサービスの提供にあたって、本サービスについて受講者としての会員登録を要することを明示するものとします。会員は、本サービスを介さないで顧客に対してスクールサービスを提供することはできません。
          </li>
          <li>
            会員は、販売を行うにあたり、特定商取引に関する法律、割賦販売法、不当景品類及び不当表示防止法、個人情報の保護に関する法律、資金決済に関する法律、消費者契約法、犯罪による収益の移転防止に関する法律その他関係法令を遵守しなければなりません。
            会員は、事業者の名称、住所、代表者の氏名、連絡が取れる電話番号その他特定商取引に関する法律で要求される事項及び当社が要求する事項を表示しなければならないものとします。
          </li>
          <li>
            会員は、スクールサービスについて、顧客の購入手続完了日から 30
            日以内に当該顧客が会員に対して返金を求める旨請求したとき、会員は、顧客に対して当該受講料の全額を遅滞なく返還しなければなりません。
          </li>
          <li>
            会員は、顧客又は第三者との間で紛争が生じた場合、会員の責任及び負担において誠実に当該紛争を解決するものとします。当社が顧客その他の第三者に損害賠償を行った場合、会員は、その賠償額の全額を当社に支払うとともに、その解決のために要した弁護士費用その他一切の諸経費を当社に支払うものとします。
          </li>
          <li>
            当社は、会員と顧客その他の第三者との間の紛争について、会員の同意を得ることなく、当該顧客又は第三者に対し、当該紛争に関する情報提供その他の援助を行うことができるものとします。
          </li>
        </ol>
        <h3>第 6 条 禁止コンテンツ</h3>
        <p>会員は、スクールサービスを提供するにあたり、以下に掲げる内容を含むことを禁じます。 禁止内容</p>
        <ul>
          <li>露骨な性描写・性行為、それらを暗示する内容</li>
          <li>過度な肌の露出</li>
          <li>差別的な内容</li>
          <li>武器・兵器の使用や作成の方法</li>
          <li>暴力的な内容</li>
          <li>薬物の乱用について</li>
          <li>動物虐待</li>
          <li>違法行為の指南</li>
          <li>各種ハラスメントを助長する内容</li>
          <li>科学・医学的に誤った情報を広げる内容</li>
        </ul>
        <h3>第 7 条 システム利用料</h3>
        <p>
          会員は、当社に対し、本サービスに係るシステム利用の対価として、別途当社の定めるシステム利用料（以下「システム利用料」といいます。）を別途当社の定める方法により支払うものとします。
        </p>
        <h3>第 8 条 届出事項の変更等</h3>
        <ol>
          <li>
            会員は、登録情報に変更のあった場合は、別途当社が定める方法により遅滞なく変更後の情報を提供するものとします。
          </li>
          <li>
            当社からの会員に対する通知については、登録情報に対して発信又は発送するものとし、会員に通常到達すべきときに到達したとみなします。
          </li>
          <li>
            会員は、当社が求める場合、直ちに会員自身のパスポート、運転免許証、マイナンバーカードその他の身分証明書（会員が法人である場合には登記事項証明書、代表取締役の身分証明書を含む。）の写しを当社の指示に従って当社に対し提供しなければならないものとします。
          </li>
        </ol>
        <h3>第 9 条 個人情報等の取扱い</h3>
        <ol>
          <li>
            当社は、会員から提供された個人情報を本サービスの提供に必要な範囲及び当社のプライバシーポリシーで定められた目的の範囲内で使用します。
          </li>
          <li>
            会員は、本サービスを利用し、又はスクールサービスを提供するにあたり、個人情報の保護に関する法律を遵守しなければなりません。
          </li>
          <li>
            会員は、スクールサービスを提供するにあたり、プライバシーポリシーを作成し、公表しなければなりません。当社は、当該プライバシーポリシーの内容を確認し、会員に対して変更を求めることができるものとし、会員は、これに応じて速やかにプライバシーポリシーを変更しなければなりません。
          </li>
        </ol>
        <h3>第 10 条 退会</h3>
        <ol>
          <li>
            会員は、当社が別途定める手続により退会し、当社との間の利用契約を終了することができます。この場合、月の途中であっても残日数につき日割り計算でシステム利用料を返還することは行いません。
          </li>
          <li>
            会員が死亡した場合、解散した場合その他アカウントの利用が不可能又は著しく困難となる事由が発生したと当社が認める場合は、当社は、当該会員がその時点で退会したものとみなし、当該アカウントの利用を停止させ、又は取り消すことができます。
          </li>
        </ol>
        <h3>第 11 条 アカウントの利用停止又は取り消し</h3>
        <ol>
          <li>
            当社は、会員が以下の事由の一にても該当する場合、会員に対し、何らの通知又は催告を要することなく、当該会員のアカウントの利用を停止させ、又は取り消すことができるものとします（以下「利用停止処分等」といいます。）。
          </li>
          <li>アカウント又は本サービスを不正に使用し、又は使用させた場合</li>
          <li>登録情報に虚偽の事実があることが判明した場合</li>
          <li>
            当社又は第三者に対し損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合
          </li>
          <li>手段の如何を問わず、本サービスの運営を妨害した場合 5.手形又は小切手につき、不渡りとなった場合</li>
          <li>租税公課の滞納処分を受けた場合</li>
          <li>後見開始、保佐開始又は補助開始の審判を受けた場合</li>
          <li>1 ヶ月以上本サービスの利用がなく、当社からの連絡に対して何らの応答がない場合</li>
          <li>第 2 条第 4 項各号に該当する場合</li>
          <li>
            差押え、仮差押え、仮処分、強制執行、破産手続開始、再生手続開始、更生手続開始、特別清算開始の申立てがあった場合
          </li>
          <li>本利用規約、ガイドラインその他当社の定める規程に違反した場合</li>
          <li>その他、会員として不適格と当社が判断した場合</li>
          <li>
            前項各号のいずれかの事由に該当した場合、会員は、当社に対して負っている金銭債務の一切について当然に期限の利益を失い、当社に対して全ての債務につき直ちに全額を支払わなければなりません。
          </li>
          <li>当社は、利用停止処分等により会員に損害が生じたとしても、一切の責任を負いません。</li>
        </ol>
        <h3>第 12 条 本サービスの変更及び廃止</h3>
        <p>
          当社は、いつでも本サービスの内容を予告なく変更又は廃止することができるものとします。当社は、本サービスの内容の変更又は廃止により会員に生じた損害については、一切の責任を負いません。
        </p>
        <h3>第 13 条 本サービスの停止</h3>
        <p>
          当社は、次の各号の事由が生じた場合には、会員に事前に通知することなく本サービスの全部又は一部を停止することができるものとし、当該停止により会員に生じた損害については一切の責任を負いません。
        </p>
        <ol>
          <li>本サービスの提供のための装置、システムの保守又は点検を行う場合</li>
          <li>コンピュータ、通信回線その他のアーキテクチャが事故により停止した場合</li>
          <li>
            天災地変、火災、停電、地震、津波、感染症、内乱、戦争その他不可抗力又は第三者からの不正な攻撃若しくは当社の利用するシステムの障害により、本サービスの運営が困難な場合
          </li>
          <li>その他、当社が停止を必要と判断した場合</li>
        </ol>
        <h3>第 14 条 情報の保存</h3>
        <p>
          会員は、本サービスを利用するにあたり、自らの責任で自らのスクールサービスに必要な情報についてのバックアップをとらなければなりません。当社は、バックアップの義務を負わず、当該情報が消滅した場合でも、それについて一切の責任を負わないものとします。
        </p>
        <h3>第 15 条 知的財産権</h3>
        <ol>
          <li>
            本サービスに関する著作権その他の知的財産権は、会員が従前に保有していたもの及び会員の独自の創作部分に係るものを除き、全て当社に帰属し、会員は、当社の許諾がない限り、本サービスによって作成された会員のウェブサイト以外でそれらを利用することができません。
          </li>
          <li>
            当社は、本サービスを運営するにあたり必要な限度で、会員が本サービスによって作成されたウェブサイト上の画像、テキストその他のコンテンツを利用することができます。
          </li>
        </ol>
        <h3>第 16 条 禁止行為</h3>
        <p>
          会員は、本サービスの利用において、以下の各号のいずれかに該当する行為又はそのおそれがある行為をしてはならないものとします。
        </p>
        <ol>
          <li>
            本サービス上であるか否かを問わず、当社又は第三者の財産権、知的財産権、名誉権、プライバシー権、肖像権、パブリシティ権その他の権利利益を侵害する行為
          </li>
          <li>
            本サービス上であるか否かを問わず、虚偽の風説の流布、営業若しくは運営の妨害その他当社又は第三者の名誉若しくは信用又はブランドを毀損する行為
          </li>
          <li>個人情報を売買する行為</li>
          <li>違法行為若しくは公序良俗に反する行為又はそれらを助長する行為</li>
          <li>猥褻な情報及び未成年者にとって有害と認められる情報の提供行為</li>
          <li>コンピュータウィルスその他有害なプログラムを使用し、又は提供する行為</li>
          <li>他人になりすまして情報を送信、受信又は表示する行為</li>
          <li>IP アドレス、アカウント、パスワード、E-メールアドレス、及びドメイン名を不正に使用する行為</li>
          <li>本サービスを当社の許可なく第三者に利用させる行為</li>
          <li>本サービスにおいて当社又は第三者が入力した情報を不正に改ざんする行為</li>
          <li>サーバその他本サービスに係るコンピュータに不正にアクセスする行為</li>
          <li>選挙期間中であるか否かを問わず、選挙運動又はこれに類似する行為</li>
          <li>本サービスと同種、又は類似の業務を行う行為</li>
          <li>その他当社が不適当と判断する行為</li>
        </ol>
        <h3>第 17 条 本サービスの責任の範囲、免責事項</h3>
        <ol>
          <li>
            当社は、会員が本サービスを利用する際に、コンピュータウィルスなど有害なプログラム等による損害を受けないことを保証しないものとします。
          </li>
          <li>
            当社は、会員が本サービスを利用する際に使用するいかなる機器、ソフトウェアについても、その動作保証を一切しないものとします。
          </li>
          <li>当社は、会員が本サービスを利用する際に発生する通信費用について、一切負担しないものとします。</li>
          <li>
            当社は、会員が本サービスを利用することにより一定の売上を得ることができることを保証するものではありません。
          </li>
          <li>
            会員は、本サービスを利用することが、会員に適用のある法令（特定商取引に関する法律を含みますが、これに限られません。）、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、会員による本サービスの利用が、会員に適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。
          </li>
          <li>
            会員との間、若しくは会員と第三者（顧客を含みますがこれに限られません。）との間で生じたトラブルに関しては、会員の責任において処理及び解決するものとし、当社はかかる事項について一切責任を負わないこととします。ただし、当社に故意又は重大な過失がある場合はこの限りではありません。
          </li>
          <li>
            会員は、本サービスを利用するに当たっては、自己の責任において当社がウェブサイトにおいて提示している利用方法を確認するものとし、会員の操作ミスについて当社は一切の責任を負わないものとします。
          </li>
        </ol>
        <h3>第 18 条 契約期間</h3>
        <ol>
          <li>利用契約の期間は、別途当社の定めるプランによります。</li>
          <li>
            会員は、利用契約が終了した場合には、本サービス及び本サービス上で提供されたものを利用できなくなります。これによって当該会員が損害を被った場合でも、当社は一切の責任を負いません。
          </li>
        </ol>
        <h3>第 19 条 権利義務譲渡禁止</h3>
        <ol>
          <li>
            会員は、当社の書面による事前の承諾なく、利用契約上の地位又は本利用規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保権の設定その他の処分をすることはできません。
          </li>
          <li>
            当社は、本サービスに係る事業を事業譲渡、会社分割その他の方法により第三者に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本利用規約に基づく権利及び義務並びに会員の登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、会員は、当該譲渡につき予め同意したものとみなします。
          </li>
        </ol>
        <h3>第 20 条 紛争処理及び損害賠償</h3>
        <ol>
          <li>
            会員は、本利用規約に違反することにより、又は本サービスの利用に関連して当社に損害を与えた場合、当社に対し、その損害（現実に発生した弁護士費用その他人件費を含む。）を賠償しなければなりません。
          </li>
          <li>
            会員が、本サービスに関連して第三者からクレームを受け、又は第三者との間で紛争を生じた場合、直ちにその内容を当社に通知するとともに、会員の責任と負担において当該クレーム又は紛争を処理し、その経過及び結果を当社に報告するものとします。
          </li>
          <li>
            会員による本サービスの利用に関連して、当社が、第三者から権利侵害その他の理由により何らかの請求を受けた場合、会員は、当社が当該第三者に対して支払うべき金額を賠償又は補償しなければなりません。
          </li>
          <li>
            当社は、会員に対して、本サービスに関連して会員が被った損害について、当社に故意又は重過失がある場合を除き、直接かつ現実の通常損害（逸失利益を除く。）に限り、当該会員が従前に現実に支払ったシステム利用料の総額を上限として賠償の責任を負います。
          </li>
        </ol>
        <h3>第 21 条 分離可能性</h3>
        <p>
          本利用規約のいずれかの条項又はその一部が、消費者契約法その他法令により無効又は執行不能と判断された場合であっても、当該判断につき実質的に対象外となった本利用規約の残部については、継続して完全に効力を有し、当社及び会員は、当該無効又は執行不能の部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効又は執行不能な部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。
        </p>
        <h3>第 22 条 準拠法及び管轄</h3>
        <ol>
          <li>本利用規約は、日本法に準拠し、日本法に従って解釈します。</li>
          <li>
            本利用規約に関して紛争が生じた場合、訴額に応じ東京簡易裁判所又は東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </li>
        </ol>
        <h3>第 23 条 本利用規約の変更</h3>
        <ol>
          <li>当社は、本利用規約につき、会員の事前の承諾なく変更することができます。</li>
          <li>
            本利用規約の変更について、当社がウェブサイトで本利用規約の変更の事実及び変更内容並びにその効力発生時期を公表し、又はこれらを会員に通知した後、当該効力発生時期が到来した時に、会員は、当該変更内容を承認したものとみなします。
          </li>
        </ol>
        <h2>第２章 受講者について</h2>
        <h3>第 24 条 会員資格</h3>
        <ol>
          <li>
            受講者会員とは、本利用規約に同意の上、次条に基づいて当社が定める方法によりスクールサービス利用のために入会を申し込み、適正な手続を経て当社が承諾した者をいいます。
          </li>
          <li>受講者会員は、会員との間で別途契約を締結するものとします。</li>
        </ol>
        <h3>第 25 条 受講申請</h3>
        <ol>
          <li>
            受講者会員となることを希望する者（以下「受講希望者」といいます。）は、受講者会員となる本人がオンラインにより別途当社が指定する方法により入会を申し込むものとします（以下「受講申請」といいます。）。受講希望者は、受講申請にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません（以下、当社に提供された情報を「受講者登録情報」といいます。）。
          </li>
          <li>
            受講申請は、前項の申込みに対する当社の承諾をもって完了するものとし、当該完了をもって受講希望者は受講者会員となります。
          </li>
          <li>
            受講申請完了時に、本利用規約に従った受講管理契約（以下「受講管理契約」といいます。）が受講者会員と当社の間に成立します。
          </li>
          <li>
            当社は、受講希望者が、本利用規約第 2 条第 4
            項各号のいずれかに該当する場合は、受講申請を拒否することがあります。
          </li>
        </ol>
        <h3>第 26 条 サービスの利用</h3>
        <ol>
          <li>受講者会員は、本利用規約のほか、当社が定める方法に従い、本サービスを利用することができます。</li>
          <li>本利用規約第 3 条、第 8 条及び第 10 条乃至第 23 条の規定は受講者会員に準用します。</li>
        </ol>
        <p>制定日：2022 年 6 月 13 日</p>
      </main>
      <style jsx>{styles}</style>
    </>
  );
};
